import "core-js/modules/es.object.to-string.js";
import { Message, Modal, Notice } from 'view-ui-plus';
import Setting from '@/setting';
import { reject } from "lodash/collection";
var errorMap = {};
var prefixHandle = function prefixHandle() {
  var title = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '温馨提示';
  var content = arguments.length > 1 ? arguments[1] : undefined;
  var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : Setting.request.modalDuration;
  Notice.config({
    top: 10,
    duration: duration
  });
  return new Promise(function (resolve) {
    if (!content || !errorMap[content]) {
      errorMap[content] = 1;
      var options = {
        name: content,
        title: title,
        desc: content,
        onClose: function onClose() {
          delete errorMap[content];
        }
      };
      resolve(options);
    } else {
      resolve(false);
    }
  });
};
var prefixMessageHandle = function prefixMessageHandle(content) {
  var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Setting.request.modalDuration;
  return new Promise(function (resolve, reject) {
    if (!errorMap[content]) {
      errorMap[content] = 1;
      content = content || '';
      if (content == '') {
        return;
      }
      if (duration != 0) {
        duration = duration || 3;
      }
      var options = {
        content: content,
        duration: duration,
        onClose: function onClose() {
          delete errorMap[content];
        }
      };
      resolve(options);
    } else {
      resolve(false);
    }
  });
};
var prefixModalHandle = function prefixModalHandle(_ref) {
  var _ref$title = _ref.title,
    title = _ref$title === void 0 ? "提示" : _ref$title,
    content = _ref.content,
    _ref$ok = _ref.ok,
    ok = _ref$ok === void 0 ? function () {} : _ref$ok,
    _ref$cancel = _ref.cancel,
    cancel = _ref$cancel === void 0 ? function () {} : _ref$cancel,
    _ref$okText = _ref.okText,
    okText = _ref$okText === void 0 ? '' : _ref$okText,
    _ref$cancelText = _ref.cancelText,
    cancelText = _ref$cancelText === void 0 ? '' : _ref$cancelText;
  return new Promise(function (resolve) {
    content = content || '';
    if (content === '') {
      return;
    }
    var options = {
      content: content
    };
    if (title) {
      options.title = title;
    }
    if (ok && ok instanceof Function) {
      options.onOk = ok;
    }
    if (cancel && cancel instanceof Function) {
      options.onCancel = cancel;
    }
    if (okText !== '') {
      options.okText = okText;
    }
    if (cancelText !== '') {
      options.cancelText = cancelText;
    }
    resolve(options);
  });
};
export default {
  Notice: {
    success: function success(content) {
      prefixHandle('成功提醒', content).then(function (options) {
        options && Notice.success(options);
      });
    },
    info: function info(content) {
      prefixHandle('温馨提示', content).then(function (options) {
        options && Notice.info(options);
      });
    },
    error: function error(content) {
      prefixHandle('失败提醒', content).then(function (options) {
        options && Notice.error(options);
      });
    },
    warning: function warning(content) {
      prefixHandle('警告', content).then(function (options) {
        options && Notice.warning(options);
      });
    },
    destroy: function destroy() {
      Notice.destroy();
    }
  },
  Message: {
    info: function info(content) {
      prefixMessageHandle(content).then(function (options) {
        options && Message.info(options);
      });
    },
    success: function success(content) {
      prefixMessageHandle(content).then(function (options) {
        options && Message.success(options);
      });
    },
    error: function error(content) {
      prefixMessageHandle(content).then(function (options) {
        options && Message.error(options);
      });
    },
    warning: function warning(content) {
      prefixMessageHandle(content).then(function (options) {
        options && Message.warning(options);
      });
    },
    loading: function loading(content, duration) {
      prefixMessageHandle(content, duration).then(function (options) {
        options && Message.loading(options);
      });
    }
  },
  Modal: {
    info: function info(_ref2) {
      var title = _ref2.title,
        content = _ref2.content,
        ok = _ref2.ok,
        okText = _ref2.okText;
      prefixModalHandle({
        title: title,
        content: content,
        ok: ok,
        okText: okText
      }).then(function (options) {
        Modal.info(options);
      });
    },
    success: function success(_ref3) {
      var title = _ref3.title,
        content = _ref3.content,
        ok = _ref3.ok,
        okText = _ref3.okText;
      prefixModalHandle({
        title: title,
        content: content,
        ok: ok,
        okText: okText
      }).then(function (options) {
        Modal.success(options);
      });
    },
    error: function error(_ref4) {
      var title = _ref4.title,
        content = _ref4.content,
        ok = _ref4.ok,
        okText = _ref4.okText;
      prefixModalHandle({
        title: title,
        content: content,
        ok: ok,
        okText: okText
      }).then(function (options) {
        Modal.error(options);
      });
    },
    warning: function warning(_ref5) {
      var title = _ref5.title,
        content = _ref5.content,
        ok = _ref5.ok,
        okText = _ref5.okText;
      prefixModalHandle({
        title: title,
        content: content,
        ok: ok,
        okText: okText
      }).then(function (options) {
        Modal.warning(options);
      });
    },
    confirm: function confirm(_ref6) {
      var title = _ref6.title,
        content = _ref6.content,
        ok = _ref6.ok,
        cancel = _ref6.cancel,
        okText = _ref6.okText,
        cancelText = _ref6.cancelText;
      prefixModalHandle({
        title: title,
        content: content,
        ok: ok,
        cancel: cancel,
        okText: okText,
        cancelText: cancelText
      }).then(function (options) {
        Modal.confirm(options);
      });
    }
  }
};